import { render } from "./TicketsNewOpenChart.vue?vue&type=template&id=6da2aba0&ts=true"
import script from "./TicketsNewOpenChart.vue?vue&type=script&lang=ts"
export * from "./TicketsNewOpenChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__